import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: { principalCity },
} = loanFormModel;

export class PrincipalCityValidation implements ValidationSchema {
  public name = principalCity.name;
  public label = '';
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: principalCity.requiredErrorMsg,
    value: principalCity.required,
  };
  public nullable = true;
}
export default new Validation(new PrincipalCityValidation());
